import React from "react";

import Footer from "../Components/Footer";
import NavBar from "../Components/NavBar";
import SingleService from "../Components/SingleService";
import VR from "../assets/images/vr.jpeg";

const Services = () => {
  return (
    <>

      <div className="pages">
      <NavBar/>
<div id="services-page">
  <section id="speciality">
          {" "}
          <h3>We are specialists in the following IT Services:</h3>
        </section>
        <div id="services-container">
        <SingleService
          summary="We offer a highly secured e-commerce platform where businesses of all sizes and individuals can connect with a wide range of customers and suppliers."
          component="B3BMarket"
          route="virtual-market"
          name="Virtual Marketplace"
          img="https://firebasestorage.googleapis.com/v0/b/indian-database.appspot.com/o/E-commerce.png?alt=media&token=fdf512e6-fcff-40e4-90bc-4ac654d91249"
        />


        <SingleService
          summary="Our engineers make it possible for you to have a full experience of a place that is thousands of miles away from your current location in real time. "
          component="WebDevelopment"
          route="metaverse-tourism"
          name="Virtual Tourism"
          img={VR}
        />

        <SingleService
          summary="We have a highly specialized team in modern website designs. Our team takes not of every micro-detail of your needs and convert it into a design that will be accessible on the web. "
          component="WebDevelopment"
          route="web-development"
          name="Web Design and Development"
          img="https://firebasestorage.googleapis.com/v0/b/indian-database.appspot.com/o/Web%20Dev.png?alt=media&token=f989050a-9d24-4eb3-b71f-c75bc696ddcd"
        />
   
      
        <SingleService
          summary="Our engineers are always ready to deliver a custom Mobile or Desktop Application for your businees or personal needs."
          component="MobileAndDesktop"
          route="mobile-and-desktop"
          name="Mobile and Desktop Application Development"
          img="https://firebasestorage.googleapis.com/v0/b/indian-database.appspot.com/o/Mobile%20app.jpeg?alt=media&token=9bf0e69c-326a-40fb-bfb2-2720a62ebb8f"
        />
        </div>

</div>
      
     
      </div>
      <Footer />
    </>
  );
};
export default Services;
